import { render, staticRenderFns } from "./ProjectsReport.vue?vue&type=template&id=12a40e4b&scoped=true"
import script from "./ProjectsReport.vue?vue&type=script&lang=js"
export * from "./ProjectsReport.vue?vue&type=script&lang=js"
import style0 from "./ProjectsReport.vue?vue&type=style&index=0&id=12a40e4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a40e4b",
  null
  
)

export default component.exports